/**
 * @generated SignedSource<<2f7eaabd75b86a900dbd9c4167c63170>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type createSongInput = {
  artist: string;
  clientMutationId?: string | null;
  title: string;
};
export type CreateSongMutation$variables = {
  connections: ReadonlyArray<string>;
  input: createSongInput;
};
export type CreateSongMutation$data = {
  readonly createSong: {
    readonly errors: ReadonlyArray<{
      readonly __typename: "AuthError";
      readonly message: string;
    }>;
    readonly song: {
      readonly id: string;
    } | null;
    readonly songEdge: {
      readonly __typename: "UserSongsEdge";
      readonly cursor: string;
      readonly node: {
        readonly artist: string;
        readonly id: string;
        readonly permissions: ReadonlyArray<{
          readonly canEdit: boolean;
          readonly didAccept: boolean;
          readonly email: string;
          readonly isOwner: boolean;
          readonly user: string;
        }>;
        readonly tags: ReadonlyArray<string>;
        readonly title: string;
        readonly viewerPermission: {
          readonly canEdit: boolean;
          readonly didAccept: boolean;
          readonly email: string;
          readonly isOwner: boolean;
          readonly user: string;
        };
      } | null;
    };
  } | null;
};
export type CreateSongMutation = {
  response: CreateSongMutation$data;
  variables: CreateSongMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Song",
  "kind": "LinkedField",
  "name": "song",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "user",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isOwner",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canEdit",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "didAccept",
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "UserSongsEdge",
  "kind": "LinkedField",
  "name": "songEdge",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Song",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "artist",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tags",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SongPermission",
          "kind": "LinkedField",
          "name": "permissions",
          "plural": true,
          "selections": (v5/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SongPermission",
          "kind": "LinkedField",
          "name": "viewerPermission",
          "plural": false,
          "selections": (v5/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "AuthError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSongMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "createSongPayload",
        "kind": "LinkedField",
        "name": "createSong",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateSongMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "createSongPayload",
        "kind": "LinkedField",
        "name": "createSong",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendEdge",
            "key": "",
            "kind": "LinkedHandle",
            "name": "songEdge",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c11da8cb50be507e952b8d23697e84f4",
    "id": null,
    "metadata": {},
    "name": "CreateSongMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSongMutation(\n  $input: createSongInput!\n) {\n  createSong(input: $input) {\n    song {\n      id\n    }\n    songEdge {\n      __typename\n      cursor\n      node {\n        id\n        title\n        artist\n        tags\n        permissions {\n          user\n          email\n          isOwner\n          canEdit\n          didAccept\n        }\n        viewerPermission {\n          user\n          email\n          isOwner\n          canEdit\n          didAccept\n        }\n      }\n    }\n    errors {\n      __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8efd915504fccf7a34a92773d57357f6";

export default node;
